// src/api/axiosInstance.js
import axios from 'axios';
import Endpoints from './endpoints';
import { logout } from '../redux/auth/authSlice';

let store;
export const injectStore = (_store) => {
  store = _store;
};


const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true
});

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRefreshed() {
  refreshSubscribers.forEach((cb) => cb());
  refreshSubscribers = [];
}

api.interceptors.response.use(
  res => res,
  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loops
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if(isRefreshing) {
        return new Promise((resolve) => {
          subscribeTokenRefresh(()=> resolve(api(originalRequest)));
        });
      }
      
      isRefreshing = true;

      try {
        await api.post(Endpoints.auth.refreshtoken, null, { withCredentials: true }); // refresh uses refreshToken cookie
        isRefreshing = false;
        onRefreshed();
        return api(originalRequest); // retry original request
      } catch (refreshError) {
        isRefreshing = false;
        if (store) {
          store.dispatch(logout());
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;